import { render, staticRenderFns } from "./Horarios.vue?vue&type=template&id=21716db5&scoped=true"
import script from "./Horarios.vue?vue&type=script&lang=js"
export * from "./Horarios.vue?vue&type=script&lang=js"
import style0 from "./Horarios.vue?vue&type=style&index=0&id=21716db5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21716db5",
  null
  
)

export default component.exports